import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import LoadingSpinner from "../../elements/loading-spinner";
import SwipeIcon from "../../svg-icons/swipe-gesture";
import * as THREE from "three";
import classNames from "classnames";
import { merge } from "lodash";
import "./style.scss";

const Viewer = ({ fields, canvas, scene, data, children, loanBannerHeight }) => {
  const mount = useRef(null);
  const [loaded, setLoaded] = useState(false);
  const { car3d } = fields;
  const { carModel, stageModel, cubeMap, numberplate, car, carMetallicRough, floor, typeAO, typeNormal, snowflake1, snowflake2 } = car3d?.fields || {};
  const webGLAssets = {
    car: { type: "model", path: carModel.value?.src },
    stage: { type: "model", path: stageModel.value?.src },
    refl: {
      type: "cubemap",
      path: cubeMap.value?.src
    },
    numberPlateAlbedo: {
      type: "texture",
      path: numberplate.value?.src
    },
    carAlbedo: {
      type: "texture",
      path: car.value?.src
    },
    carMetallicRough: {
      type: "texture",
      path: carMetallicRough.value?.src
    },
    floorAlbedo: {
      type: "texture",
      path: floor.value?.src
    },
    tyreAO: {
      type: "texture",
      path: typeAO.value?.src
    },
    tyreNormal: {
      type: "texture",
      path: typeNormal.value?.src
    },
    snowflake1: {
      type: "texture",
      path: snowflake1.value?.src
    },
    snowflake2: {
      type: "texture",
      path: snowflake2.value?.src
    }
  };
  scene.assets = merge({}, scene.assets, webGLAssets);


  const initialize = async () => {
    var renderer = new THREE.WebGLRenderer({ antialias: true });
    mount.current.appendChild(renderer.domElement);
    scene.data = data;
    canvas.init(renderer, mount.current);
    canvas.loadScene(scene, () => setLoaded(true));
  };

  useEffect(() => {
    initialize();
    return canvas.onDestroy.bind(canvas);
  }, []);
  

  useEffect(() => {
    handleLoanBannerScroll()
  }, [loanBannerHeight]);

  const handleLoanBannerScroll = () => {
    let position = document.getElementsByTagName("html")[0].scrollTop;
    let carModelElem = document.getElementsByClassName("webgl-window") 

    if(loanBannerHeight > 0 && position > 0) {
    carModelElem[0].style.top = `${loanBannerHeight + 60}px`;
    } 
    if(!loanBannerHeight) {
      carModelElem[0].style.top = "60px"
    }
    
  }

  return (
    <div className="webgl-window" id="webgl-window">
      <div className="viewport" ref={mount} />
      <div className={classNames("loading-screen", { "fade-out": loaded })}>
        <LoadingSpinner />
      </div>
      {loaded && (
        <div className="interaction-hint">
          <SwipeIcon />
        </div>
      )}
      {children}
      <div className="top-fade" />
      <div className="bottom-fade" />
    </div>
  );
};

Viewer.propTypes = {
  canvas: PropTypes.object,
  scene: PropTypes.object,
  data: PropTypes.object
};
//
// Viewer.defaultProps = {
//   data: {
//     blueColor: {
//       color: 0x071a2e,
//       metalness: 0.8
//     },
//     blackColor: {
//       color: 0x040404,
//       metalness: 0.1
//     }
//   }
// };

export default Viewer;
